module.exports = __webpack_public_path__ + "img/cloud-drizzle-sun-2.9f740924.svg";